import { ClientTransportDiscovery } from "./client-transport-discovery.js";
import { canonicalHttpsOrigin } from "./http-origin.js";
import { HttpWsHomeNodeClient } from "./http-home-node-client.js";
export async function createWanHomeNodeClient(candidate, options, signal) {
    if (candidate.path !== "wan-direct")
        throw new TypeError("WAN client received a non-WAN candidate");
    const origin = canonicalHttpsOrigin(candidate.address);
    const accessToken = await options.accessToken?.();
    const delegation = await options.delegationCredential?.();
    const headers = {};
    if (accessToken !== undefined)
        headers.authorization = `Bearer ${accessToken}`;
    if (delegation !== undefined)
        headers["x-client-device-delegation"] = delegation;
    const discovery = new ClientTransportDiscovery(options.fetch === undefined ? {} : { fetch: options.fetch });
    if (candidate.identityBinding === "bootstrap") {
        await discovery.establishTrust(origin, headers, signal);
    }
    else {
        const advertised = await discovery.refresh(origin, candidate.id, headers, signal);
        if (advertised.wan.address !== origin) {
            throw new TypeError("WAN candidate was not the authenticated canonical WAN origin");
        }
    }
    return new HttpWsHomeNodeClient({
        ...options,
        baseUrl: origin,
        transportPath: "wan-direct",
    });
}
//# sourceMappingURL=wan-client.js.map